import React from 'react'

import { MenuItemType } from '@monorepo/deprecated/interfaces'
import { MenuItem } from './MenuItem'

type MenuItemsListProps = React.HTMLAttributes<HTMLUListElement> & {
  items: MenuItemType[]
}

export const MenuItemsList: React.FC<MenuItemsListProps> = ({
  items,
  ...props
}) => (
  <ul {...props}>
    {items.map((item, idx) => (
      <MenuItem key={idx} item={item} />
    ))}
  </ul>
)
